<script>
export default {
  name: 'round-pool',

  data() {
    return {
      isLoading: true,
    }
  },

  props: [
    'competitionID',
    'results',
    'round',
    'pool'
  ],

  template: `
    <div>
    <a :id="pool.key" :href="'pool/' + pool.key">
      <div class="match-details">
        <div class="match-date">{{ round.date | formatDate }}</div>
        <div class="match-position">{{ pool.title }}</div>
      </div>
      <div class="match-entity">
        <div class="entity-name">{{ pool.title }}</div>
      </div>
    </a>
    </div>
  `
}
</script>

<style scoped>
</style>
